// documentacion / documentation
// liquid ajax cart v2
// https://liquid-ajax-cart.js.org/v2/installation/

const changePlan = (event, line, quantity) => {
    window.liquidAjaxCart?.change({
        line,
        quantity,
        selling_plan: event.target.value === "null" ? null : event.target.value
    });
}
const closeCart = _ => {
    document.body.classList.remove('js-show-ajax-cart');
}
const openCart = _ => {
    document.body.classList.add('js-show-ajax-cart');
}
// disable rebuy only theme
document.addEventListener('rebuy:smartcart.ready', (event) => {
    Rebuy.SmartCart.destroy()
});
document.addEventListener("theme:product:added", _ => {
    liquidAjaxCart.add({}, {
        lastCallback: _ => {
            document.body.classList.add('js-show-ajax-cart');
        }
    })
})
/* document.addEventListener('liquid-ajax-cart:request-end', event => {
  const {requestState} = event.detail;
    console.log("first")
  if (requestState.requestType === 'add' && requestState.responseData?.ok) {
    // Add the CSS class to the "body" tag
    document.body.classList.add('js-show-ajax-cart');
  }
}); */